<div *ngIf="!(isMobile$ | async)">
  <table mat-table [dataSource]="devices">
    <!-- Manufacturer Column -->
    <ng-container matColumnDef="manufacturer">
      <th mat-header-cell *matHeaderCellDef>Manufacturer</th>
      <td mat-cell *matCellDef="let element">
        {{ element.manufacturer }}
        <sbnb-cs-debug-item
          label="Lock ID"
          (click)="$event.stopPropagation()"
          [coreNovaLink]="'/dashboards/smartlocks?lock-id=' + element.id"
          [value]="element.id"
          linkLabel="Nova"></sbnb-cs-debug-item>
      </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Device name</th>
      <td mat-cell *matCellDef="let element">
        {{ element.name }}
      </td>
    </ng-container>

    <!-- Online Column -->
    <ng-container matColumnDef="online">
      <th mat-header-cell *matHeaderCellDef>Online</th>
      <td mat-cell *matCellDef="let element">
        <ng-template
          [ngTemplateOutlet]="onlineImageTemplate"
          [ngTemplateOutletContext]="{ element: element }"></ng-template>
      </td>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let element">
        <sbnb-button
          size="mini"
          type="primary-teal"
          [matTooltip]="element.unsupported_message"
          [disabled]="element.unsupported_message || !canAction"
          (clicked)="onMatchClicked(element)">
          Match
        </sbnb-button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>

<div *ngIf="isMobile$ | async" class="mobile-devices-table">
  <mat-card *ngFor="let device of devices">
    <mat-card-content>
      <div fxLayout="column" fxLayoutGap="12px">
        <div fxLayoutAlign="start center" fxLayoutGap="12px">
          <ng-template
            [ngTemplateOutlet]="onlineImageTemplate"
            [ngTemplateOutletContext]="{ element: device }"></ng-template>
          <div fxLayout="column" fxFlex>
            <a class="strong ellipsis">{{ device.name }}</a>
            <span>{{ device.manufacturer }}</span>
          </div>

          <sbnb-button
            size="mini"
            type="primary-teal"
            [disabled]="device.unsupported_message"
            (clicked)="onMatchClicked(device)">
            Match
          </sbnb-button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<ng-template #onlineImageTemplate let-element="element">
  <img
    *ngIf="element.device_properties.online"
    src="assets/iconography/online-antenna.svg"
    class="device-status-icon"
    alt="online" />
  <img
    *ngIf="!element.device_properties.online"
    src="assets/iconography/offline-antenna.svg"
    class="device-status-icon"
    alt="offline"
    [matTooltip]="element.issues | deviceIssuesTooltip" />
</ng-template>
